import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import StoreDetailsBasic from '@/plugins/graphql/queries/v2/store_manager/store-details-basic.gql';
import { StoreBasicModel } from '@/helpers/entities/models/StoreBasicModel';
import ActionButton from '@/components/action_button/Index.vue';
import BaseDetailsCard from '@/components/v2/BaseDetailsCard';
import BaseDetails from '@/components/v2/BaseDetails';
import BaseImageThumbnail from '@/components/v2/BaseImageThumbnail';
import { STORE_EDIT_ROUTE } from '@/helpers/constants/StoreManagerRoutes';
/**
 * Store Details Page
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.21.0}
 */
let StoreDetails = class StoreDetails extends Mixins(RouteParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.store = null;
    }
    goToEditPage(uuid) {
        this.$router.push({
            name: STORE_EDIT_ROUTE.name,
            params: {
                uuid,
            },
        });
    }
};
StoreDetails = __decorate([
    Component({
        apollo: {
            store: {
                query: StoreDetailsBasic,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return new StoreBasicModel(data.app);
                },
            },
        },
        components: {
            ActionButton,
            BaseDetails,
            BaseDetailsCard,
            BaseImageThumbnail,
        },
    })
], StoreDetails);
export default StoreDetails;
